<script setup>
defineProps({
  intro: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="adda-intro">
    <div class="row-270-20 p-bot-1 max">
      <div class="main-section">
        <div class="left">
          <!-- eslint-disable vue/no-v-html -->
          <h1
            v-if="intro.titolo"
            class="heading-1 intro-page"
            v-html="intro.titolo"
          />
          <div class="flex-intro m-top-3 text-2">
            <div v-if="intro.testoSinistra">
              <!-- eslint-disable vue/no-v-html -->
              <div v-html="intro.testoSinistra" />
            </div>
            <div v-if="intro.testoDestra">
              <!-- eslint-disable vue/no-v-html -->
              <div v-html="intro.testoDestra" />
            </div>
          </div>
        </div>
        <div class="right">
          <div class="img-container">
            <DefaultPicture
              v-if="intro.portrait.responsiveImage"
              :image="{
                portrait: intro.portrait.responsiveImage,
              }"
              :lazy-load="true"
              :alt="intro.titolo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddaIntro',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
